import {
  VentaPendienteMaster,
  formatComprobanteVentaMasterDisplay,
} from '../../../services/ventasSeguimientoService';
import { POSLineaPendienteMeta } from './types';

export {
  documentoOrigenSigueEnRenglones,
  lineaTieneOrigenMaster,
  numeroComercialDesdeDisplay,
  numerosComercialesDeLineas,
} from './origenPedidoFactura';

export function pendienteMetaDesdeMaster(p: VentaPendienteMaster): POSLineaPendienteMeta {
  return {
    comprobanteDisplay: formatComprobanteVentaMasterDisplay(p),
    fechaEmision: p.fechaEmisionComprobanteMaster ?? null,
    cantidadPedida: p.cantidadPedida,
    cantidadFacturada: p.cantidadFacturada,
    cantidadRemitida: p.cantidadRemitida,
    pendienteFacturar: p.pendienteFacturar,
    pendienteEntregar: p.pendienteEntregar,
  };
}

export function formatFechaEmisionMaster(value?: string | null): string {
  if (!value) return '—';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return '—';
  return parsed.toLocaleDateString('es-AR');
}
